const sizes: any = [0, 5, 10, 15, 20, 25, 30, 35, 40]

sizes.m = '100%';
sizes.t = null;
sizes.d = null;
sizes.xd = '1152px';

export default sizes;